import { FC, ReactNode } from 'react';
import { Header, HeaderGroup } from '@tanstack/react-table';
import EmptyCell from '../EmptyCell/EmptyCell';
import HeaderTitleCell from './TitleCell/TitleCell';
import { TableSort } from '../../';
import st from './Header.module.scss';

interface IMainTitleRowProps {
	sort?: TableSort;
	minColumnSize?: number;
	headerGroup: HeaderGroup<any>;
	renderFirstToolbar?: () => ReactNode;
}

const MainTitleRow: FC<IMainTitleRowProps> = (props) => {
	const { minColumnSize, renderFirstToolbar, headerGroup, sort } = props;

	/** Рендер ячейки шапки таблицы  */
	const renderHeaderCell = (header: Header<any, any>, index: number) => {
		return (
			<HeaderTitleCell
				key={'MainHeaderCell_' + header.id}
				header={header}
				minColumnSize={minColumnSize}
				sort={sort}
				colSpan={header.colSpan}
				width={header.getSize()}
				isLast={index === headerGroup.headers.length - 1}
			/>
		);
	};

	return (
		<tr key={headerGroup.id + '_titles'} className={st.mainRow}>
			{renderFirstToolbar ? (
				renderFirstToolbar()
			) : (
				<EmptyCell isHeader width={32} />
			)}
			{headerGroup.headers.map(renderHeaderCell)}
			<EmptyCell isHeader width={32} />
		</tr>
	);
};

export default MainTitleRow;
